module.exports = __webpack_public_path__ + "img/badge-earned-modal.4c8f35.svg";